import type { PageContext } from "vike/types";
import translate from "@/services/translate";

export default (pageContext: PageContext) => translate(pageContext)("title");
